import { IRefCode } from "@interfaces/user/refs";
import { createContext, useContext } from "react";

export const RefCodeContext = createContext<IRefCode>(undefined as any);
export const RefCodeProvider = RefCodeContext.Provider;

export function useRefCodeContext() : IRefCode | undefined {
    return useContext(RefCodeContext)
}